import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Datenschutz() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page" data-testid="datenschutz-page">
      <div className="legal-container">
        <Link to="/" className="legal-back" data-testid="datenschutz-back-link">
          <ArrowLeft strokeWidth={1.5} size={18} /> Zurück zur Startseite
        </Link>

        <h1 className="legal-title">Datenschutzerklärung</h1>
        <p className="legal-intro">Diese Datenschutzerklärung gilt für die Website www.mitgefuehl.live</p>

        <div className="legal-content">
          <div className="legal-address-block">
            <p><strong>Verantwortlicher:</strong></p>
            <p>Vanessa Würzler<br />Sophienstraße 77<br />64711 Erbach<br />impressum@mitgefuehl.live</p>
          </div>

          <h2>Verarbeitung von personenbezogenen Daten</h2>
          <p>Wir verarbeiten im Rahmen der Website personenbezogene Daten von Ihnen unter anderem wie folgt:</p>

          <h3>Logfiles beim Besuch der Website</h3>
          <p>Bei der Nutzung unserer Webseite werden von unserem Hostinganbieter bei jedem Zugriff auf die Server sog. „Logfile"-Daten protokolliert wie bspw. Name der aufgerufenen Website, zuvor besuchte Seite, Produkt- und Versionsinformation des verwendeten Browsers und des Betriebssystems, anfragender Provider, Datum und Uhrzeit des Zugangs, IP-Adresse.</p>
          <p>Rechtsgrundlage für die Verarbeitung ist Artikel 6 Absatz 1 f) DSGVO. Die Logfile-Daten werden nach höchstens 30 Tagen gelöscht oder anonymisiert.</p>

          <h3>Kontaktaufnahme</h3>
          <p>Bei Kontaktanfragen verarbeiten wir Ihre personenbezogenen Daten wie Name, Anschrift, E-Mail-Adresse, Telefonnummer, die wir für die Beantwortung Ihres Anliegens benötigen. Rechtsgrundlage ist Art. 6 Abs. 1 b) DSGVO, sofern Ihr Anliegen auf den Abschluss eines Vertrages gerichtet ist, ansonsten Art. 6 Abs. 1 f) DSGVO.</p>

          <h3>Registrierung / Bestellungen</h3>
          <p>Bei Ihrer Registrierung oder Bestellungen verarbeiten wir Ihre personenbezogenen Daten wie Name, Anschrift, E-Mail-Adresse, Telefonnummer, Zahlungsdaten, die wir für die Erfüllung des Vertragsverhältnisses benötigen. Rechtsgrundlage ist Art. 6 Abs. 1 b) DSGVO.</p>

          <h3>Teilnahme an unseren Sitzungen</h3>
          <p>Im Rahmen Ihrer Teilnahme an unseren Sitzungen verarbeiten wir personenbezogene Daten zu Ihrer persönlichen Situation und Ihrem individuellen Coaching-Bedarf. Videokonferenzen zeichnen wir nicht auf. Rechtsgrundlage ist Art. 6 Abs. 1 b) DSGVO.</p>

          <h2>Cookies</h2>
          <p>Cookies sind kleine Textdateien, die auf dem Computer des Nutzers gespeichert werden und die eine Analyse der Benutzung der Website ermöglichen. Sofern durch einzelne von uns eingesetzte Cookies auch personenbezogene Daten verarbeitet werden, erfolgt die Verarbeitung gemäß Art. 6 Abs. 1 b) DSGVO zur Durchführung des Vertrages, gemäß Art. 6 Abs. 1 a) DSGVO im Falle einer erteilten Einwilligung oder gemäß Art. 6 Abs. 1 f) DSGVO zur Wahrung unserer berechtigten Interessen.</p>
          <p>Sie haben jederzeit die Möglichkeit, eine erteilte Einwilligung in das Setzen von Cookies zu widerrufen, indem Sie die Cookies in den Einstellungen Ihres Browsers löschen.</p>

          <h2>Zoom</h2>
          <p>Wir nutzen Zoom (Zoom Video Communications, Inc.) um Online-Meetings und Videokonferenzen durchzuführen. Bei der Nutzung von Zoom werden Teilnehmerdaten, Meeting-Metadaten sowie ggf. Audio- und Videodaten verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b) DS-GVO. Zoom kann Daten an Server weltweit übermitteln und stützt Datenübermittlungen in die USA auf den EU-US Datenschutzrahmen.</p>

          <h2>Instagram-Präsenz</h2>
          <p>Wir betreiben eine Präsenz auf Instagram (Meta Platforms Ireland Ltd.). Bei einem Besuch auf unserer Instagram-Seite werden von Meta über den Einsatz von Cookies personenbezogene Daten erhoben. Für die Verarbeitung der Insights-Daten sind wir und Meta gemeinsame Verantwortliche.</p>

          <h2>Betroffenenrechte</h2>
          <p>Sie haben gemäß DSGVO folgende Rechte:</p>
          <ul>
            <li><strong>Auskunftsrecht</strong> (Art. 15 DSGVO)</li>
            <li><strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO)</li>
            <li><strong>Recht auf Löschung</strong> (Art. 17 DSGVO)</li>
            <li><strong>Recht auf Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
            <li><strong>Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
          </ul>
          <p>Sie haben das Recht, sich bei der zuständigen Aufsichtsbehörde zu beschweren.</p>

          <h2>Widerrufsrecht</h2>
          <p>Ihre ggf. erteilte Einwilligung in die Verarbeitung Ihrer personenbezogenen Daten können Sie jederzeit widerrufen, bspw. per E-Mail an impressum@mitgefuehl.live. Die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung wird dadurch nicht berührt.</p>

          <h2>Widerspruchsrecht</h2>
          <p>Soweit unsere Datenverarbeitung auf Artikel 6 Absatz 1 f) DSGVO beruht, haben Sie nach näherer Maßgabe des Artikel 21 DSGVO das Recht, der Verarbeitung Ihrer personenbezogenen Daten zu widersprechen.</p>
        </div>
      </div>
    </div>
  );
}
